import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:1700',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('micus_consult_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url: string = err?.config?.url || '';
    if (status === 401 && !url.startsWith('/auth/login') && localStorage.getItem('micus_consult_token')) {
      localStorage.removeItem('micus_consult_token');
      localStorage.removeItem('micus_consult_user');
      window.location.assign('/login?expired=1');
    }
    return Promise.reject(err);
  },
);

export default api;
